export default __webpack_public_path__ + "static/media/img_publi7.e26f32f0.svg";